import { Masonry } from "@mui/lab";
import { Box, Pagination, Paper } from "@mui/material";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SaleActivityType } from "../../../api/psc";
import {
    DialogContainer,
    EmptyListMessage,
    EndOfInfiniteListMessage,
    Spinner,
} from "../../../components/exports";
import PageWithFilter from "../../../components/shared/PageWithFilter";
import { DialogContext } from "../../../contexts/DialogueContext";
import {
    fetchActivities,
    resetAndFetchActivities,
} from "../../../slices/ActivitySlice";
import { RootState } from "../../../slices/Store";
import ActivityFilter from "../components/ActivityFilter";
import SaleActivityItem from "../components/SaleActivityItem";
import TodayHeader from "../components/TodayHeader";
import { TodayType } from "./Today";

export default function TodayNotes(props: {
    type: TodayType;
    onChange: (type: TodayType) => void;
}) {
    const dispatch = useDispatch();
    const { openDialog } = useContext(DialogContext);
    const activityState = useSelector(
        (state: RootState) => state.activityState
    );
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        resetAndFetchActivities(SaleActivityType.NOTE, activityState, dispatch);
    }, []);

    useEffect(() => {
        if (!activityState.isFetching && isLoading) {
            setIsLoading(false);
        }
    }, [activityState.isFetching]);

    const handlePageChange = (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        fetchActivities(
            SaleActivityType.NOTE,
            activityState,
            dispatch,
            page - 1
        );
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const openFilter = () => {
        openDialog(
            <DialogContainer>
                <ActivityFilter type={SaleActivityType.TASK} />
            </DialogContainer>
        );
    };

    return (
        <Box>
            <PageWithFilter
                filter={<ActivityFilter type={SaleActivityType.NOTE} />}
            >
                <TodayHeader
                    type={props.type}
                    onChange={props.onChange}
                    openFilter={openFilter}
                    totalCount={activityState.totalCount}
                />

                {(isLoading || activityState.isFetching) && <Spinner />}

                {!isLoading && (
                    <>
                        {!activityState.isFetching &&
                            activityState.activities.length === 0 && (
                                <EmptyListMessage message="نظری یافت نشد" />
                            )}

                        {activityState.activities.length > 0 && (
                            <>
                                <Masonry
                                    columns={{
                                        xl: 3,
                                        lg: 3,
                                        md: 2,
                                        sm: 2,
                                        xs: 1,
                                    }}
                                    spacing={2}
                                >
                                    {activityState.activities.map((p) => {
                                        return (
                                            <Paper key={p.id}>
                                                <SaleActivityItem
                                                    saleId={p.saleId}
                                                    activity={p}
                                                    showProjectViewButton={true}
                                                />
                                            </Paper>
                                        );
                                    })}
                                </Masonry>

                                {activityState.totalCount >
                                activityState.limit ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            mt: 2,
                                        }}
                                    >
                                        <Pagination
                                            count={Math.ceil(
                                                activityState.totalCount /
                                                    activityState.limit
                                            )}
                                            color="primary"
                                            page={activityState.page + 1}
                                            onChange={handlePageChange}
                                        />
                                    </Box>
                                ) : (
                                    <EndOfInfiniteListMessage />
                                )}
                            </>
                        )}
                    </>
                )}
            </PageWithFilter>
        </Box>
    );
}
